import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../slider.css";

import { projects } from "../projects";

const ProjectSlider = () => {
  const { pages } = projects;
  return (
    <Swiper
      modules={[Pagination, Navigation]}
      pagination={{ clickable: true }}
      navigation={true}
      className="productSlider min-h-[500px]"
    >
      {pages.map((page, index) => {
        return (
          <SwiperSlide key={index}>
            <div className="grid grid-cols-2 gap-x-5 md:grid-cols-3 lg:grid-cols-4 lg:gap-[30px]">
              {page.projectsList.map((product, index) => {
                const { image, name, place } = product;
                return (
                  <div
                    className="w-full max-w-[230px] lg:max-w-[290px] h-[300px] lg:h-[380px] text-left"
                    key={index}
                  >
                    <div className="border hover:border-[#550a0f] rounded-[18px] w-full max-w-[285px] h-full max-h-[202px] lg:max-h-[272px] flex items-center justify-center mb-[15px] relative transition">
                      <img src={image.type} alt="" />
                    </div>
                    <div className="font-semibold lg:text-xl">{name}</div>
                    <div className="flex items-center gap-x-3">
                      <div> {place}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default ProjectSlider;
